var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.widgetReady)?_c('div',[_c('top-bar',{attrs:{"consultant-id":_vm.consultantId}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('ac-footer'),_vm._v(" "),_c('inactivity-modal')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }